/* global $ */
import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import Swal from 'sweetalert2';

function PreEvaluationTest() {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [newRecord, setNewRecord] = useState({
        batch_no: '',
        training_title: '',
        sr_no: '',
        Name: '',
        pre_evaluation_test: '',
    });
    const [searchText, setSearchText] = useState('');
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [selectedBatchNo, setSelectedBatchNo] = useState('');

    useEffect(() => {
        const handleModalClose = () => {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

            $('body').css({
                'padding-right': '',
                'overflow': ''
            });

            $('.content-wrapper').css('min-height', 'calc(100vh - 114px)');
        };

        $('#editRowModal').on('hidden.bs.modal', handleModalClose);
        return () => $('#editRowModal').off('hidden.bs.modal', handleModalClose);
    }, []);

    useEffect(() => {
        const fetchBatchNumbers = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/batchno_tab');

                // Extract unique batch numbers for the dropdown
                const uniqueBatchNumbers = [...new Set(response.data.map(item => item.batch_no))];
                setBatchNumbers(uniqueBatchNumbers);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchBatchNumbers();
    }, []);


    const handleEdit = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to edit this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, edit it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            setSelectedRow(row);
            setNewRecord({
                batch_no: row.batch_no,
                sr_no: row.sr_no,
                Name: row.Name,
                pre_evaluation_test: row.pre_evaluation_test,
            });
            $('#editRowModal').modal('show');
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        if (!selectedRow) return;

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to save the changes?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, save it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {

            const updatedData = {
                mas_id: selectedRow.mas_id,
                pre_evaluation_test: newRecord.pre_evaluation_test,
            };

            try {
                await axios.put(`https://api.eazyworldehsengineering.com/api/candidate_registration/${selectedRow.mas_id}`, updatedData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                setData(data.map(item =>
                    item.mas_id === selectedRow.mas_id
                        ? { ...item, ...updatedData } // merge changes into existing item
                        : item
                ));

                $('#editRowModal').modal('hide');
                Swal.fire('Saved!', 'The record has been updated.', 'success');
            } catch (error) {
                console.error('Error updating data:', error);
                Swal.fire('Error!', 'There was an issue updating the record.', 'error');
            }
        }
    };


    const handleViewButtonClick = async () => {
        if (!selectedBatchNo) {
            Swal.fire('Error!', 'Please select a batch number.', 'error');
            return;
        }

        setIsLoading(true); // Set loading state

        try {
            const response = await axios.get(`https://api.eazyworldehsengineering.com/api/candidate_registration/?batch_no=${selectedBatchNo}`);

            // Check if the data is valid before setting it
            if (response.data && Array.isArray(response.data)) {
                setData(response.data);
            } else {
                Swal.fire('Error!', 'Unexpected data format received.', 'error');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire('Error!', 'There was an issue fetching the data.', 'error');
        } finally {
            setIsLoading(false); // Reset loading state
        }
    };

    const handleResetButtonClick = () => {
        setSelectedBatchNo(''); // Clear dropdown selection
        setData([]); // Clear DataTable data
    };

    const handleInputChange = (event) => {
        const { id, value } = event.target;
        setNewRecord(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const filteredData = data.filter(item => {
        return (
            (item.batch_no && item.batch_no.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.batch_status && item.batch_status.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.batch_date && item.batch_date.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.city_name && item.city_name.toLowerCase().includes(searchText.toLowerCase()))
        );
    });


    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Batch No</span>,
            selector: row => row.batch_no,
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>R.No</span>,
            selector: row => row.sr_no,
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Name</span>,
            selector: row => row.Name,
            width: '200px',
            sortable: true,
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Training Title</span>,
            selector: row => row.training_title,
            width: '300px',
            sortable: true,
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Designation</span>,
            selector: row => row.designation,
            sortable: true,
            width: '200px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Contact No</span>,
            selector: row => row.contact_no,
            width: '120px',
            sortable: true,
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Pre Evaluation</span>,
            selector: row => row.pre_evaluation_test,
            width: '120px',
            sortable: true,
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Action</span>,
            cell: row => (
                <div>
                    <button className="btn btn-primary btn-sm mr-2" onClick={() => handleEdit(row)}>
                        <i className="fa fa-edit"></i>
                    </button>
                </div>
            ),
            width: '120px',
            ignoreRowClick: true,
            allowoverflow: true,
        }
    ];
    return (
        <div className="content-wrapper">
            {/* Page Header */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Pre Evaluation Test</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Pre Evaluation Test</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Filter Card */}
            <div className="row mb-2">
                <div className="col-md-12">
                    <div className="card card-primary card-outline">
                        <div className="card-header">
                            <h5 className="card-title"><i className="fas fa-filter mr-2"></i> Filter Records</h5>
                        </div>
                        <div className="card-body">
                            <div className="form-row align-items-end">
                                <div className="form-group col-md-3"></div>

                                <div className="form-group col-md-3">
                                    <label>Select Batch Number</label>
                                    <select
                                        id="batchNumber"
                                        className="form-control select2"
                                        value={selectedBatchNo}
                                        onChange={(e) => setSelectedBatchNo(e.target.value)}
                                    >
                                        <option value="">Select a batch number</option>
                                        {batchNumbers.map(batchNo => (
                                            <option key={batchNo} value={batchNo}>{batchNo}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group col-md-3 d-flex gap-2">
                                    <button
                                        className="btn btn-primary mr-2"
                                        onClick={handleViewButtonClick}
                                        disabled={isLoading}
                                    >
                                        <i className="fas fa-eye mr-1"></i> View
                                    </button>
                                    <button
                                        className="btn btn-secondary"
                                        onClick={handleResetButtonClick}
                                    >
                                        <i className="fas fa-redo mr-1"></i> Reset
                                    </button>
                                </div>

                                <div className="form-group col-md-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Results Section */}
            <div className="row">
                <div className="col-12">
                    <div className="card card-info card-outline">
                        <div className="card-header">
                            <h5 className="card-title"><i className="fas fa-table mr-2"></i> Results</h5>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="form-control mb-3"
                                />
                            </div>

                            <div className="table-responsive">
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    paginationPerPage={100}
                                    paginationRowsPerPageOptions={[100, 200, 300, 400]}
                                    highlightOnHover
                                    striped
                                    className="table table-bordered table-hover"
                                />

                                {/* Edit Modal */}
                                <div className="modal fade" id="editRowModal">
                                    <div className="modal-dialog modal-lg modal-dialog-scrollable">
                                        <div className="modal-content">
                                            <form onSubmit={handleFormSubmit}>
                                                <div className="modal-header bg-primary">
                                                    <h4 className="modal-title text-white">Edit Pre Evaluation Test</h4>
                                                    <button type="button" className="close text-white" data-dismiss="modal">
                                                        <span>&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <label>Batch No</label>
                                                            <input
                                                                id="batch_no"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.batch_no || ''}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label>Roll No</label>
                                                            <input
                                                                id="sr_no"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.sr_no || ''}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <label>Name</label>
                                                            <input
                                                                id="Name"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.Name || ''}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label>Pre Evaluation Mark</label>
                                                            <input
                                                                id="pre_evaluation_test"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.pre_evaluation_test || ''}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer justify-content-between">
                                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                                        Close
                                                    </button>
                                                    <button type="submit" className="btn btn-success">
                                                        Save Changes
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default PreEvaluationTest